module.exports = __webpack_public_path__ + "static/media/实名制_lg.b7d4d30e.jpg";